<template>
  <div>
    <AppHeader/>
    
    <!-- 主视觉区域 - 关于我们 -->
    <section class="relative h-96 flex items-center justify-center text-white bg-gradient-stone pt-16 overflow-hidden">
      <div class="absolute inset-0">
        <img :alt="$t('about.hero.title')" class="w-full h-full object-cover opacity-40"
          src="/images/about/about-hero-bg.jpg">
      </div>
      <div class="relative z-10 text-center px-4 max-w-4xl">
        <h1 class="text-5xl md:text-6xl font-extrabold leading-tight mb-4 animate-fade-in-up">
          {{ $t('about.hero.title') }}
        </h1>
        <p class="text-xl md:text-2xl mb-6 max-w-3xl mx-auto animate-fade-in-up delay-200">
          {{ $t('about.hero.subtitle') }}
        </p>
      </div>
    </section>
    
    <!-- 公司简介 -->
    <section class="py-20 px-6 md:px-12 bg-gray-50">
      <h2 class="text-4xl font-extrabold text-center mb-14 text-gray-900">
        {{ $t('about.companyIntro.title') }}
      </h2>
      <div class="max-w-7xl mx-auto flex flex-col md:flex-row items-center md:space-x-12">
        <div class="md:w-1/2 mb-8 md:mb-0">
          <img :alt="$t('about.companyIntro.title')" class="w-full h-auto rounded-xl shadow-lg"
            src="/images/about/about-team.jpg">
        </div>
        <div class="md:w-1/2">
          <p class="text-gray-700 leading-relaxed text-lg mb-4">
            {{ $t('about.companyIntro.paragraph1') }}
          </p>
          <p class="text-gray-700 leading-relaxed text-lg">
            {{ $t('about.companyIntro.paragraph2') }}
          </p>
        </div>
      </div>
    </section>
    
    <!-- 我们的使命与愿景 -->
    <section class="py-20 px-6 md:px-12 bg-white">
      <h2 class="text-4xl font-extrabold text-center mb-14 text-gray-900">
        {{ $t('about.missionVision.title') }}
      </h2>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-10 max-w-7xl mx-auto">
        <div class="bg-gray-50 rounded-xl shadow-xl p-8 text-center transform hover:scale-102 transition duration-300">
          <i class="fas fa-bullseye text-5xl text-purple-600 mb-6"></i>
          <h3 class="text-2xl font-bold mb-3 text-gray-900">
            {{ $t('about.missionVision.mission.title') }}
          </h3>
          <p class="text-gray-700 leading-relaxed">
            {{ $t('about.missionVision.mission.content') }}
          </p>
        </div>
        <div class="bg-gray-50 rounded-xl shadow-xl p-8 text-center transform hover:scale-102 transition duration-300">
          <i class="fas fa-lightbulb text-5xl text-purple-600 mb-6"></i>
          <h3 class="text-2xl font-bold mb-3 text-gray-900">
            {{ $t('about.missionVision.vision.title') }}
          </h3>
          <p class="text-gray-700 leading-relaxed">
            {{ $t('about.missionVision.vision.content') }}
          </p>
        </div>
      </div>
    </section>
    
    <!-- 资质认证 -->
    <section class="py-20 px-6 md:px-12 bg-gray-50">
      <h2 class="text-4xl font-extrabold text-center mb-14 text-gray-900">
        {{ $t('about.certifications.title') }}
      </h2>
      <div class="max-w-7xl mx-auto">
        <div class="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          <div class="bg-white p-6 rounded-xl shadow-lg text-center hover:shadow-xl transition-shadow duration-300">
            <i class="fas fa-certificate text-5xl text-blue-600 mb-4"></i>
            <h3 class="text-xl font-semibold mb-2">
              {{ $t('about.certifications.items.iso9001.name') }}
            </h3>
            <p class="text-gray-600 text-sm">
              {{ $t('about.certifications.items.iso9001.description') }}
            </p>
          </div>
          <div class="bg-white p-6 rounded-xl shadow-lg text-center hover:shadow-xl transition-shadow duration-300">
            <i class="fas fa-shield-alt text-5xl text-green-600 mb-4"></i>
            <h3 class="text-xl font-semibold mb-2">
              {{ $t('about.certifications.items.iso27001.name') }}
            </h3>
            <p class="text-gray-600 text-sm">
              {{ $t('about.certifications.items.iso27001.description') }}
            </p>
          </div>
          <div class="bg-white p-6 rounded-xl shadow-lg text-center hover:shadow-xl transition-shadow duration-300">
            <i class="fas fa-server text-5xl text-purple-600 mb-4"></i>
            <h3 class="text-xl font-semibold mb-2">
              {{ $t('about.certifications.items.idcIsp.name') }}
          </h3>
            <p class="text-gray-600 text-sm">
              {{ $t('about.certifications.items.idcIsp.description') }}
          </p>
        </div>
          <div class="bg-white p-6 rounded-xl shadow-lg text-center hover:shadow-xl transition-shadow duration-300">
            <i class="fas fa-check-circle text-5xl text-yellow-600 mb-4"></i>
            <h3 class="text-xl font-semibold mb-2">
              {{ $t('about.certifications.items.imda.name') }}
          </h3>
            <p class="text-gray-600 text-sm">
              {{ $t('about.certifications.items.imda.description') }}
          </p>
          </div>
        </div>
        <div class="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div class="bg-white p-6 rounded-xl shadow-lg text-center hover:shadow-xl transition-shadow duration-300">
            <i class="fab fa-microsoft text-5xl text-blue-800 mb-4"></i>
            <h3 class="text-xl font-semibold mb-2">
              {{ $t('about.certifications.items.microsoft.name') }}
          </h3>
            <p class="text-gray-600 text-sm">
              {{ $t('about.certifications.items.microsoft.description') }}
          </p>
        </div>
          <div class="bg-white p-6 rounded-xl shadow-lg text-center hover:shadow-xl transition-shadow duration-300">
            <i class="fab fa-aws text-5xl text-orange-600 mb-4"></i>
            <h3 class="text-xl font-semibold mb-2">
              {{ $t('about.certifications.items.aws.name') }}
          </h3>
            <p class="text-gray-600 text-sm">
              {{ $t('about.certifications.items.aws.description') }}
          </p>
        </div>
          <div class="bg-white p-6 rounded-xl shadow-lg text-center hover:shadow-xl transition-shadow duration-300">
            <div class="flex items-center justify-center h-20 mb-4">
              <img src="/images/about/huawei-cloud-logo.png" :alt="$t('about.certifications.items.huawei.name')" class="max-w-full max-h-full object-contain"/>
            </div>
            <h3 class="text-xl font-semibold mb-2">
              {{ $t('about.certifications.items.huawei.name') }}
          </h3>
            <p class="text-gray-600 text-sm">
              {{ $t('about.certifications.items.huawei.description') }}
          </p>
        </div>
          <div class="bg-white p-6 rounded-xl shadow-lg text-center hover:shadow-xl transition-shadow duration-300">
            <i class="fas fa-award text-5xl text-indigo-600 mb-4"></i>
            <h3 class="text-xl font-semibold mb-2">
              {{ $t('about.certifications.items.award.name') }}
          </h3>
            <p class="text-gray-600 text-sm">
              {{ $t('about.certifications.items.award.description') }}
          </p>
          </div>
        </div>
      </div>
    </section>
    
    <!-- 亚太地区服务网络 -->
    <section class="py-20 px-6 md:px-12 bg-white">
      <h2 class="text-4xl font-extrabold text-center mb-14 text-gray-900">
        {{ $t('about.serviceNetwork.title') }}
      </h2>
      <p class="text-center text-gray-600 text-lg mb-12 max-w-3xl mx-auto">
        {{ $t('about.serviceNetwork.subtitle') }}
      </p>
      
      <div class="max-w-7xl mx-auto bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-200">
        <div class="grid grid-cols-1 md:grid-cols-3 border-b border-gray-200 bg-gray-50">
          <div
            v-for="metric in serviceNetworkMetrics"
            :key="metric.label"
            class="px-6 py-5 text-center border-b md:border-b-0 md:border-r last:border-r-0 border-gray-200"
          >
            <div class="text-3xl font-extrabold text-purple-700">{{ metric.value }}</div>
            <div class="mt-1 text-sm font-semibold text-gray-600">{{ metric.label }}</div>
          </div>
        </div>

        <!-- 区域标签切换 -->
        <div class="border-b border-gray-200 flex flex-wrap">
          <button 
            v-for="region in aboutServiceRegions"
            :key="region.code"
            @click="activeRegion = region.code"
            :class="['region-tab', { 'active': activeRegion === region.code }]"
            class="px-6 py-4 font-medium text-gray-700 border-b-2 border-transparent hover:text-purple-700"
          >
            <i class="fas fa-map-marker-alt mr-2 text-red-500"></i>{{ region.name }}
          </button>
        </div>
        
        <!-- 区域内容 -->
        <div class="p-8 md:p-12">
          <div
            v-for="region in aboutServiceRegions"
            :key="`${region.code}-content`"
            :class="['region-content', { 'active': activeRegion === region.code }]"
          >
            <div class="flex flex-col md:flex-row gap-8 items-center">
              <div class="md:w-1/2">
                <img :alt="region.name" class="w-full h-auto rounded-xl shadow-lg" :src="region.image"/>
              </div>
              <div class="md:w-1/2">
                <h3 class="text-3xl font-bold mb-4 text-gray-900">{{ region.name }}</h3>
                <p class="text-xl text-purple-700 mb-6 font-semibold">{{ region.office }}</p>
                
                <div class="space-y-4 mb-8">
                  <div
                    v-for="office in region.offices"
                    :key="office.id"
                    class="flex items-start"
                  >
                    <i class="fas fa-building text-purple-600 mt-1 mr-3 text-xl"></i>
                    <div>
                      <h4 class="font-semibold text-gray-900">
                        {{ office.title }}
                      </h4>
                      <p
                        v-for="line in office.addressLines"
                        :key="line"
                        class="text-gray-600"
                      >
                        {{ line }}
                      </p>
                      <p v-if="office.businessHours" class="mt-1 text-sm text-gray-500">
                        <i class="far fa-clock mr-1"></i>{{ office.businessHours }}
                      </p>
                    </div>
                  </div>
                </div>
                
                <div class="bg-gray-50 p-4 rounded-lg mb-6">
                  <h4 class="font-semibold text-gray-900 mb-2">{{ $t('about.serviceNetwork.serviceScopeLabel') }}</h4>
                  <p class="text-gray-700">{{ region.description }}</p>
                </div>

                <div class="bg-purple-50 p-4 rounded-lg border-l-4 border-purple-500">
                  <h4 class="font-semibold text-gray-900 mb-2 flex items-center">
                    <i class="fas fa-globe-asia text-purple-600 mr-2"></i>{{ networkLabels.coordination }}
                  </h4>
                  <p class="text-gray-700">{{ region.coordination }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    
    <!-- 职业机会 -->
    <section class="py-20 px-6 md:px-12 bg-gradient-stone text-white">
      <div class="max-w-5xl mx-auto text-center">
        <h2 class="text-4xl font-extrabold mb-8">
          {{ $t('about.cta.title') }}
        </h2>
        <p class="text-xl leading-relaxed mb-12 opacity-90">
          {{ $t('about.cta.description') }}
        </p>
        <router-link to="/contact" class="inline-block bg-white text-purple-700 hover:bg-purple-100 px-8 py-4 rounded-full text-lg font-semibold shadow-lg transition duration-300 transform hover:scale-105">
          {{ $t('about.cta.button') }}
          <i class="fas fa-arrow-right ml-2"></i>
        </router-link>
      </div>
    </section>
    
    <!-- 底部页脚 -->
    <AppFooter />
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'
import { useSeoMeta } from '@/composables/useSeoMeta'
import serviceRegionsData from '@/data/serviceRegions'

// 当前激活的区域
const activeRegion = ref('CN')
const { locale } = useI18n()

const regionImages = {
  CN: '/images/about/region-china.jpg',
  HK: '/images/about/region-hongkong.jpg',
  MO: '/images/about/region-macau-it.jpg',
  TW: '/images/about/region-taiwan.jpg',
  JP: '/images/about/region-japan.jpg',
  KR: '/images/about/region-korea.jpg',
  AU: '/images/about/region-australia-it.jpg',
  SG: '/images/about/region-singapore.jpg',
  MY: '/images/about/region-malaysia-it.jpg',
  PH: '/images/about/region-philippines-it.jpg',
  VN: '/images/about/region-vietnam-it.jpg'
}

const localeKey = computed(() => {
  const [baseLocale] = (locale.value || 'zh').split('-')
  return ['zh', 'en', 'ja', 'ko'].includes(baseLocale) ? baseLocale : 'en'
})

const getLocalizedText = (value) => {
  if (!value) {
    return ''
  }

  if (typeof value === 'string') {
    return value
  }

  if (Array.isArray(value)) {
    return value.filter(Boolean).join(' ')
  }

  return value[localeKey.value] ?? value.zh ?? value.en ?? Object.values(value)[0] ?? ''
}

const getLocalizedList = (value) => {
  if (!value) {
    return []
  }

  if (Array.isArray(value)) {
    return value.filter(Boolean)
  }

  if (typeof value === 'string') {
    return [value]
  }

  const localizedValue = value[localeKey.value] ?? value.zh ?? value.en ?? []
  return Array.isArray(localizedValue) ? localizedValue.filter(Boolean) : [localizedValue].filter(Boolean)
}

const isRegionComingSoon = region => region.offices.every(office => office.isComingSoon)

const networkLabels = computed(() => {
  const labels = {
    zh: {
      serviceRegions: '服务地区',
      activeCenters: '已运营中心',
      serviceNodes: '服务节点',
      coordination: '区域协同能力'
    },
    en: {
      serviceRegions: 'Service Regions',
      activeCenters: 'Active Centers',
      serviceNodes: 'Service Nodes',
      coordination: 'Regional Coordination'
    },
    ja: {
      serviceRegions: 'サービス地域',
      activeCenters: '稼働拠点',
      serviceNodes: 'サービスノード',
      coordination: '地域連携能力'
    },
    ko: {
      serviceRegions: '서비스 지역',
      activeCenters: '운영 센터',
      serviceNodes: '서비스 노드',
      coordination: '지역 협업 역량'
    }
  }

  return labels[localeKey.value] || labels.zh
})

const getRegionCoordinationText = (region, isComingSoon) => {
  const regionName = getLocalizedText(region.name)
  const labels = {
    zh: isComingSoon
      ? `${regionName}由已运营的亚太服务中心与区域团队协同承接，支持远程响应、现场协调与项目交付联动。`
      : `${regionName}可联动周边服务节点，支持现场响应、远程支持与跨区域项目交付。`,
    en: isComingSoon
      ? `${regionName} is coordinated through active APAC service centers and regional teams for remote response, onsite coordination, and project delivery.`
      : `${regionName} can coordinate with nearby service nodes for onsite response, remote support, and cross-region delivery.`,
    ja: isComingSoon
      ? `${regionName}は稼働中のAPACサービス拠点と地域チームが連携し、リモート対応、オンサイト調整、案件デリバリーを支援します。`
      : `${regionName}は周辺サービス拠点と連携し、オンサイト対応、リモート支援、広域案件のデリバリーに対応します。`,
    ko: isComingSoon
      ? `${regionName}는 운영 중인 APAC 서비스 센터와 지역 팀이 연계해 원격 대응, 온사이트 조율, 프로젝트 딜리버리를 지원합니다.`
      : `${regionName}는 인접 서비스 거점과 연계해 온사이트 대응, 원격 지원, 지역 간 프로젝트 딜리버리를 지원합니다.`
  }

  return labels[localeKey.value] || labels.zh
}

const getRegionOfficeText = (region, isComingSoon) => {
  if (!isComingSoon) {
    return getLocalizedText(region.office)
  }

  const cityName = getLocalizedText(region.city)
  const labels = {
    zh: `${cityName}区域协同服务覆盖`,
    en: `${cityName} coordinated service coverage`,
    ja: `${cityName}地域連携サービスカバレッジ`,
    ko: `${cityName} 지역 협업 서비스 커버리지`
  }

  return labels[localeKey.value] || labels.zh
}

const getRegionDescriptionText = (region, isComingSoon) => {
  if (!isComingSoon) {
    return getLocalizedText(region.description)
  }

  const regionName = getLocalizedText(region.name)
  const labels = {
    zh: `${regionName}已纳入亚太服务网络，可通过周边已运营服务中心提供远程支持、现场协调与项目交付协同。`,
    en: `${regionName} is included in the APAC service network, with remote support, onsite coordination, and project delivery supported through nearby active service centers.`,
    ja: `${regionName}はAPACサービスネットワークに含まれており、稼働中の周辺サービス拠点を通じてリモート支援、オンサイト調整、案件デリバリーを支援します。`,
    ko: `${regionName}는 APAC 서비스 네트워크에 포함되어 있으며 인접 운영 서비스 센터를 통해 원격 지원, 온사이트 조율, 프로젝트 딜리버리를 지원합니다.`
  }

  return labels[localeKey.value] || labels.zh
}

const getOfficeAddressLines = (office, region) => {
  if (!office.isComingSoon) {
    return getLocalizedList(office.addressLines)
  }

  const cityName = getLocalizedText(office.city || region.city)
  const labels = {
    zh: [`${cityName}区域服务覆盖`, '由亚太区域团队协同支持'],
    en: [`${cityName} service coverage`, 'Coordinated by APAC regional teams'],
    ja: [`${cityName}サービスカバレッジ`, 'APAC地域チームが連携して支援'],
    ko: [`${cityName} 서비스 커버리지`, 'APAC 지역 팀이 연계 지원']
  }

  return labels[localeKey.value] || labels.zh
}

const orderedServiceRegions = computed(() => [...serviceRegionsData])

const activeOfficeCount = computed(() => {
  return orderedServiceRegions.value.reduce((total, region) => {
    return total + region.offices.filter(office => !office.isComingSoon).length
  }, 0)
})

const officeCount = computed(() => {
  return orderedServiceRegions.value.reduce((total, region) => total + region.offices.length, 0)
})

const serviceNetworkMetrics = computed(() => [
  { label: networkLabels.value.serviceRegions, value: orderedServiceRegions.value.length },
  { label: networkLabels.value.activeCenters, value: activeOfficeCount.value },
  { label: networkLabels.value.serviceNodes, value: officeCount.value }
])

const aboutServiceRegions = computed(() => {
  return orderedServiceRegions.value.map((region) => {
    const isComingSoon = isRegionComingSoon(region)

    return {
      code: region.code,
      name: getLocalizedText(region.name),
      city: getLocalizedText(region.city),
      office: getRegionOfficeText(region, isComingSoon),
      description: getRegionDescriptionText(region, isComingSoon),
      coordination: getRegionCoordinationText(region, isComingSoon),
      image: regionImages[region.code] || '/images/industrySolution/industrySolutions-head.jpg',
      offices: region.offices.map(office => ({
        id: office.id,
        title: getLocalizedText(office.title),
        addressLines: getOfficeAddressLines(office, region),
        businessHours: getLocalizedText(office.businessHours || region.businessHours)
      }))
    }
  })
})

// SEO Meta tags
useSeoMeta({
  title: {
    zh: '关于我们 - Global Data',
    en: 'About Us - Global Data',
    ja: '私たちについて - 思棟株式会社',
    ko: '회사 소개 - Global Data'
  },
  description: {
    zh: 'Global Data是专注于亚太地区IT基础设施服务的专业提供商。凭借对本地市场的深入洞察与全球技术视野，我们为企业数字化转型奠定坚实的技术基石。',
    en: 'Global Data is a leading provider of IT infrastructure services in the Asia-Pacific region. Leveraging deep local market insights and a global technology perspective, we lay a solid foundation for enterprises undergoing digital transformation.',
    ja: '思棟株式会社は、アジア太平洋地域のITインフラサービスに特化した専門プロバイダーです。地域市場への深い洞察とグローバルな技術視点を活用し、企業のデジタル変革のための強固な技術基盤を築いています。',
    ko: 'Global Data는 아시아태평양 지역의 IT 인프라 서비스에 특화된 선도 기업입니다. 현지 시장에 대한 깊은 이해와 글로벌 기술 시야를 바탕으로 기업의 디지털 전환을 위한 탄탄한 기반을 구축합니다.'
  }
})
</script>

<style scoped>
@import '@/assets/css/main.css';
@import '@/assets/css/aboutView.css';
</style>
